import { setStore, getStore, keys } from '@/store'
import Vue from 'vue'
import ElementLocale from 'element-ui/lib/locale'
import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'

const localeBus = new Vue()

export function onLocaleChange (handler) {
  localeBus.$on('change', handler)
  return () => localeBus.$off('change', handler)
}

function emitLocaleChange (locale) {
  localeBus.$emit('change', locale)
}

export function normalizeLocale (locale) {
  if (!locale) {
    return (navigator.language && navigator.language.toLowerCase().includes('zh-cn')) ? 'zh_CN' : 'en'
  }
  const value = String(locale).trim().toLowerCase().replace(/-/g, '_')
  if (value === '1') {
    return 'zh_CN'
  }
  if (value === '2') {
    return 'en'
  }
  if (value === 'en' || value.startsWith('en_')) {
    return 'en'
  }
  if (value === 'zh_cn' || value === 'zh' || value.startsWith('zh')) {
    return 'zh_CN'
  }
  return 'en'
}

export function localeFromUrlLang (value) {
  if (value == null || value === '') {
    return null
  }
  const normalized = String(value).trim().toLowerCase().replace(/-/g, '_')
  if (normalized === 'zh_cn' || normalized === 'zh' || normalized.startsWith('zh') || normalized === '1') {
    return 'zh_CN'
  }
  if (normalized === 'en' || normalized.startsWith('en_') || normalized === '2') {
    return 'en'
  }
  return null
}

export function getUrlLangValue (query) {
  if (query && query.lang != null && query.lang !== '') {
    return query.lang
  }
  if (typeof window !== 'undefined') {
    try {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('lang')) {
        return urlParams.get('lang')
      }
    } catch (e) {
      // ignore
    }
  }
  return null
}

export function syncLocaleFromUrl (i18n, query) {
  const urlLocale = localeFromUrlLang(getUrlLangValue(query))
  if (urlLocale) {
    applyLocale(i18n, urlLocale)
    return urlLocale
  }
  return null
}

export function getLocaleShortLabel (locale) {
  return normalizeLocale(locale) === 'zh_CN' ? '中' : 'EN'
}

export function getRequestLang () {
  return normalizeLocale(getStore(keys.lang) || navigator.language)
}

export function getStoredLocale () {
  const urlLocale = localeFromUrlLang(getUrlLangValue())
  if (urlLocale) {
    setStore(keys.lang, urlLocale)
    return urlLocale
  }
  const stored = getStore(keys.lang)
  if (stored) {
    return normalizeLocale(stored)
  }
  const fallback = normalizeLocale(navigator.language)
  setStore(keys.lang, fallback)
  return fallback
}

export function applyElementLocale (locale) {
  const normalized = normalizeLocale(locale)
  ElementLocale.use(normalized === 'zh_CN' ? elementZh : elementEn)
  return normalized
}

export function applyLocale (i18n, locale) {
  const normalized = normalizeLocale(locale)
  const prev = normalizeLocale(getStore(keys.lang))
  setStore(keys.lang, normalized)
  i18n.locale = normalized
  applyElementLocale(normalized)
  if (prev !== normalized) {
    emitLocaleChange(normalized)
  }
  return normalized
}

export function switchUserLanguage (vm, locale) {
  const normalized = normalizeLocale(locale)
  if (getStore(keys.token)) {
    return vm.$http.post('/api/saveMemberLang', { language: normalized }).then(() => {
      applyLocale(vm.$i18n, normalized)
    }).catch((error) => {
      applyLocale(vm.$i18n, normalized)
      return Promise.reject(error)
    })
  }
  applyLocale(vm.$i18n, normalized)
  return Promise.resolve()
}



// WEBPACK FOOTER //
// ./src/utils/lang.js